// extracted by css-extract-rspack-plugin
export default {"dumbo":"u04HT8"};